<template>
    <div class="layout-main-wrapper">
        <VersionUpdate v-if="environment === 'production'"></VersionUpdate>
        <LoadingOverlay></LoadingOverlay>
        <v-main class="layout-main">
            <v-container class="page">
                <v-flex class="header">
                    <slot name="header">
                        <img class="logo" alt="Qstep logo" :src="logo.src">
                    </slot>
                </v-flex>
                <v-flex class="middle">
                    <slot></slot>
                </v-flex>
                <v-flex class="footer">
                    <slot name="footer"></slot>
                </v-flex>
            </v-container>
        </v-main>
    </div>
</template>

<script>

import VersionUpdate from '@/components/Core/VersionUpdate'
import LoadingOverlay from '@/components/Core/LoadingOverlay'

export default {
  components: {
    VersionUpdate, LoadingOverlay
  },
  props: {
    hideScrollBar: {
      type: Boolean,
      default: false
    }
  },
  model: {
    prop: 'show',
    event: 'visibility'
  },
  mounted () {
    this.handleHideScrollBar(this.hideScrollBar)
  },
  name: 'Main',
  data () {
    return {
      environment: process.env.NODE_ENV,
      logo: {
        src: require('@/assets/images/qstep-logo.png')
      }
    }
  },
  methods: {
    handleHideScrollBar (hideScrollBar) {
      if (hideScrollBar) {
        document.querySelector('html').classList.add('hide-scroll-bar')
      } else {
        document.querySelector('html').classList.remove('hide-scroll-bar')
      }
    }
  },
  watch: {
    hideScrollBar: function (hideScrollBar) {
      this.handleHideScrollBar(hideScrollBar)
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .layout-main-wrapper {
        width: 100%;

        .layout-main {
            width: 100%;
            max-width: 1140px;
            margin: 0 auto;

            .logo {
                padding-top: 5px;
            }
        }
    }
</style>

<style lang="scss">
    html.hide-scroll-bar {
        overflow: hidden !important;
    }
</style>
